// extracted by mini-css-extract-plugin
module.exports =  {"container":"PasteListModal-Hv5d__container","introduction-text":"PasteListModal-Vbd0__introduction-text"};